__turbopack_context__.v({
  "button": "MoreResultsButton-module-scss-module__cmDcza__button",
  "wrapper": "MoreResultsButton-module-scss-module__cmDcza__wrapper",
});
